"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_isequal_1 = __importDefault(require("lodash.isequal"));

function isEqual(value, other) {
  return lodash_isequal_1.default(value, other);
}

exports.isEqual = isEqual;